export const PORTFOLIO_PAR_THRESHOLDS = {
    par0: 5,
    par30: 5,
    par90: 1,
};

const PAR_KEYS = Object.keys(PORTFOLIO_PAR_THRESHOLDS);

export const getPortfolioParRatioPercent = (parValue, aum) => {
    if (!+aum) {
        return null;
    }
    return (+parValue / +aum) * 100;
};

export const isPortfolioParBreached = (parValue, aum, parKey) => {
    const threshold = PORTFOLIO_PAR_THRESHOLDS[parKey];
    if (threshold == null) {
        return false;
    }
    const ratio = getPortfolioParRatioPercent(parValue, aum);
    return ratio !== null && ratio > threshold;
};

export const isPortfolioRowParBreached = (record = {}) => {
    const { aum } = record;
    return PAR_KEYS.some((key) => isPortfolioParBreached(record[key], aum, key));
};

export const getPortfolioRowsRequiringParComment = (portfolioViewData = []) => {
    if (!Array.isArray(portfolioViewData)) {
        return [];
    }
    return portfolioViewData.filter(
        (row) =>
            row &&
            row.portfolioInstanceId != null &&
            row.key &&
            isPortfolioRowParBreached(row)
    );
};

export const hasPortfolioParCommentsForBreachedRows = (portfolioViewData = []) => {
    const rowsRequiringComment = getPortfolioRowsRequiringParComment(portfolioViewData);
    if (!rowsRequiringComment.length) {
        return true;
    }
    return rowsRequiringComment.every((row) => (row.remark_counts || 0) > 0);
};
